import { all } from 'redux-saga/effects';
import authSaga from '@iso/redux/auth/saga';
import accountboardSaga from '@iso/redux/accountBoard/saga';
import accountWizardSaga from '@iso/redux/accountWizard/saga';
import producerJobSaga from '@iso/redux/producerJob/saga';
import contractorJobSaga from '@iso/redux/contractorJob/saga';
import userSaga from '@iso/redux/user/saga';
import companySaga from '@iso/redux/company/saga';
import locationSaga from '@iso/redux/location/saga';
import jobBidSaga from '@iso/redux/jobBid/saga';
import jobDocumentSaga from '@iso/redux/jobDocument/saga';
import jobAgencySaga from '@iso/redux/jobAgency/saga';
import jobInvoiceSaga from '@iso/redux/jobInvoice/saga';
import personalNetworkSaga from '@iso/redux/personalNetwork/saga';
import companyNetworkSaga from '@iso/redux/companyNetwork/saga';
import contractorInvoiceSaga from '@iso/redux/contractorInvoice/saga';
import companyDocumentSaga from '@iso/redux/companyDocument/saga';
import walletSaga from '@iso/redux/wallet/saga';
import userIntroSaga from '@iso/redux/intro/saga';
import contactImportSaga from '@iso/redux/contactImport/saga';
import remoteConfigurationSaga from '@iso/redux/remoteConfiguration/saga';
import payByInvitationSaga from '@iso/redux/payByInvitation/saga';
import buddiBotSaga from '@iso/redux/buddibot/saga';
import featureFlagsSaga from '@iso/redux/featureFlags/saga';
import messagesSaga from '@iso/redux/messages/saga';

export default function* rootSaga(getState) {
  yield all([
    authSaga(),
    accountboardSaga(),
    accountWizardSaga(),
    producerJobSaga(),
    contractorJobSaga(),
    userSaga(),
    companySaga(),
    locationSaga(),
    jobBidSaga(),
    jobDocumentSaga(),
    jobAgencySaga(),
    jobInvoiceSaga(),
    personalNetworkSaga(),
    companyNetworkSaga(),
    contractorInvoiceSaga(),
    companyDocumentSaga(),
    walletSaga(),
    userIntroSaga(),
    contactImportSaga(),
    remoteConfigurationSaga(),
    payByInvitationSaga(),
    buddiBotSaga(),
    featureFlagsSaga(),
    messagesSaga(),
  ]);
}
